import React from "react";

import { useDocumentTitle } from "hooks/useDOcumentTitle";
import RoamingItems from "components/RoamingItems/RoamingItems";

const RoamingItemsPage: React.FC = () => {
  useDocumentTitle("Roaming Items");
  return <RoamingItems></RoamingItems>;
};

export default RoamingItemsPage;